/**
 * Documento — coreBOS standard module `Documents` (file attachments). Hand-written: not in the
 * harvested manifests. Documents <-> Accounts / Contacts / evPolicies are many-to-many in coreBOS
 * (vtiger_senotesrel); the projector (PROJECTOR_DOCUMENTS=1) folds them into these fields:
 * relaccount / relcontact / relpolicy when the document names exactly one record of that type,
 * `aziende` with every company it is filed under. A document filed under several companies has
 * no relaccount, so the organisation scope shows it among the group's records.
 */
export const documentDescriptor = {
    slug: 'cmp_document',
    kind: 'document',
    label: { singular: 'Documento', plural: 'Documenti' },
    table: 'compliance_document',
    idStrategy: 'sha256',
    fields: [
        { name: 'notes_title', type: 'text', label: 'Titolo', required: true },
        { name: 'aziende', type: 'text', label: 'Società' },
        { name: 'filename', type: 'text', label: 'File' },
        { name: 'notecontent', type: 'text', label: 'Descrizione' },
        { name: 'filetype', type: 'text', label: 'Tipo file' },
        { name: 'filesize', type: 'number', label: 'Dimensione (byte)' },
    ],
    relations: [
        { name: 'relaccount', kind: 'belongsTo', target: 'account', toEntitySpine: true },
        { name: 'relcontact', kind: 'belongsTo', target: 'contact', toEntitySpine: true },
        { name: 'relpolicy', kind: 'belongsTo', target: 'cmp_policy' },
        { name: 'assigned_user', kind: 'belongsTo', target: 'user', toEntitySpine: true },
    ],
    behaviors: { ownership: true, audit: true, softDelete: true, tenantScoped: true },
    ui: { mode: 'generated', icon: 'FileTextOutlined', navGroup: 'Policy' },
};
